import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { AppHeader, useTranslator } from "@sia/style-guide";
import "./Page.scss";

/**
 * Page component
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.className
 * @param {Object} props.contentNavigation
 * @param {React.ReactNode} props.children
 *
 * @returns {JSX.Element} The rendered React element
 */
const Page = ({ title, className, contentNavigation, children }) => {
  const translate = useTranslator();
  const createBrowserTitle = () => {
    const browserTitle = translate("benchmarking.browser.title");
    if (title) {
      const pageTitle = translate(title);
      return `${pageTitle} - ${browserTitle}`;
    }
    return browserTitle;
  };

  useEffect(() => {
    document.title = createBrowserTitle();
  });

  const renderAppHeader = () => {
    const appHeader = {
      name: "SIA-Benchmarking",
      urlPart: "",
      link: "/",
    };

    return <AppHeader appName={appHeader.name} translate={translate} link={appHeader.link} />;
  };

  return (
    <div id="page" className={className}>
      <div>
        {renderAppHeader()}
        {contentNavigation}
      </div>
      <div className="page-content">{children}</div>
    </div>
  );
};
Page.propTypes = {
  contentNavigation: PropTypes.object,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
export default Page;
